import { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

interface AdSenseProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'horizontal' | 'vertical';
  style?: React.CSSProperties;
  responsive?: boolean;
  className?: string;
}

export default function AdSense({
  slot = '',
  format = 'auto',
  style = { display: 'block' },
  responsive = true,
  className = ''
}: AdSenseProps) {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
    }
  }, []);

  const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID || 'ca-pub-3763339383362664';

  return (
    <div className={`adsense-container ${className}`}>
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client={clientId}
        data-ad-format={format}
        data-full-width-responsive={responsive}
        {...(slot && { 'data-ad-slot': slot })}
      />
    </div>
  );
}

// Componente para diferentes tipos de ads
export function SmallBannerAd({ className = '' }: { className?: string }) {
  const slot = process.env.REACT_APP_ADSENSE_BANNER_SLOT || '5440925403';

  return (
    <AdSense
      slot={slot}
      format="horizontal"
      className={className}
      style={{ display: 'block', minHeight: '50px', maxHeight: '90px' }}
    />
  );
}

export function InArticleAd({ className = '' }: { className?: string }) {
  const slot = process.env.REACT_APP_ADSENSE_INARTICLE_SLOT || '7189121348';

  return (
    <AdSense
      slot={slot}
      format="fluid"
      className={`my-4 ${className}`}
      style={{ display: 'block', textAlign: 'center', minHeight: '100px', maxHeight: '250px' }}
    />
  );
}

export function BannerAd({ className = '' }: { className?: string }) {
  const slot = process.env.REACT_APP_ADSENSE_BANNER_SLOT || '5440925403';

  return (
    <AdSense
      slot={slot}
      format="horizontal"
      className={`my-4 ${className}`}
      style={{ display: 'block', minHeight: '90px' }}
    />
  );
}
